import Vue from 'vue'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  VAvatar,
  VMenu,
  VCard,
  VExpansionPanel,
  VTextField,
  VSnackbar,
  VTabs,
  VSelect,
  VSwitch,
  transitions
} from 'vuetify'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    VAvatar,
    VMenu,
    VCard,
    VExpansionPanel,
    VTextField,
    VSnackbar,
    VTabs,
    VSelect,
    VSwitch,
    transitions
  },
})
